import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { useQuery, useMutation } from 'react-apollo';
import { toast } from 'react-toastify';

import {
  GET_DEFAULT_VISIBLE_SPECIALTIES,
  UPDATE_DEFAULT_VISIBLE_SPECIALTIES
} from '../queries';

const SpecialtySettingsTab = () => {
  const [value, setValue] = useState('');

  const { data, loading } = useQuery(GET_DEFAULT_VISIBLE_SPECIALTIES);

  const [updateDefaultVisible, { loading: saving }] = useMutation(
    UPDATE_DEFAULT_VISIBLE_SPECIALTIES
  );

  useEffect(() => {
    if (data && data.getDefaultVisibleSpecialties !== undefined) {
      setValue(data.getDefaultVisibleSpecialties);
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      await updateDefaultVisible({
        variables: {
          defaultVisibleSpecialties: Number(value)
        }
      });

      toast.success('Default visible specialties updated successfully');
    } catch (err) {
      toast.error(err.message || 'Something went wrong');
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="settings-wrapper">
      <div className="settings-row">
        <label className="settings-label">Default Categories Visible:</label>

        <input
          type="number"
          className="settings-input"
          value={value}
          onChange={e => setValue(e.target.value)}
        />

        <Button
          className="settings-submit-btn"
          onClick={handleSubmit}
          disabled={saving}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default SpecialtySettingsTab;
